import { FeatureFlags } from '../FeatureFlags';
import { RequestHelper } from '../helpers/RequestHelper';
import { ResultHelper } from '../helpers/ResultHelper';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { RemoteRefreshScheduleMapper } from '../mappers/RemoteRefreshScheduleMapper';
import { IRemoteRefreshScheduleInfo } from '../models/IRemoteRefreshScheduleInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { CreateRemoteRefreshScheduleRequest } from '../ServerApi/requests/CreateRemoteRefreshScheduleRequest';
import { DeleteRemoteRefreshSchedulesRequest } from '../ServerApi/requests/DeleteRemoteRefreshSchedulesRequest';
import { GetRemoteRefreshSchedulesRequest } from '../ServerApi/requests/GetRemoteRefreshSchedulesRequest';
import { UpdateRemoteRefreshExpectedDurationRequest } from '../ServerApi/requests/UpdateRemoteRefreshExpectedDurationRequest';
import { UpdateRemoteRefreshScheduleRequest } from '../ServerApi/requests/UpdateRemoteRefreshScheduleRequest';
import { IResult } from '../ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';

export class RemoteRefreshSchedules extends Resource<IRemoteRefreshScheduleInfo> {

  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory'];

  constructor(private ErrorNotifyingServer: ErrorNotifyingServer, FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetRemoteRefreshSchedulesRequest,
      ServerApiMapper.remoteRefreshSchedules));
  }

  public create(targetId: string, item: IRemoteRefreshScheduleInfo): ng.IPromise<IResult> {
    if (FeatureFlags.remoteRefreshSelfServiceScheduleWidgetEnabled) {
      return this.ErrorNotifyingServer.sendRequest(new CreateRemoteRefreshScheduleRequest({
        targetId: targetId,
        definition: '',
        refreshType: item.refreshType,
        schedule: {
          definition: '',
          refreshType: item.refreshType,
          scheduleDetails: item.scheduleDetails,
          scheduleType: item.scheduleType
        }
      }));
    }
    return this.ErrorNotifyingServer.sendRequest(new CreateRemoteRefreshScheduleRequest({
      targetId: targetId,
      definition: item.definition,
      refreshType: item.refreshType
    }));
  }

  public update(targetId: string, initialSchedule: IRemoteRefreshScheduleInfo, finalSchedule: IRemoteRefreshScheduleInfo): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequest(new UpdateRemoteRefreshScheduleRequest({
      targetId: targetId,
      initial: RemoteRefreshScheduleMapper.mapSingleToApi(initialSchedule),
      final: RemoteRefreshScheduleMapper.mapSingleToApi(finalSchedule)
    }));
  }

  public del(targetId: string, items: Set<IRemoteRefreshScheduleInfo>): ng.IPromise<IResult> {
    const schedules = items.toArray();
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(schedules, (schedulesBlock) =>
        new DeleteRemoteRefreshSchedulesRequest({
          targetId: targetId,
          schedules: RemoteRefreshScheduleMapper.mapToApi(schedulesBlock)
      })),
      ResultHelper.combineResults);
  }

  public updateExpectedDuration(targetId: string, finalSchedule: IRemoteRefreshScheduleInfo): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequest(new UpdateRemoteRefreshExpectedDurationRequest({
      id: targetId,
    expectedRefreshDuration: (String)(finalSchedule.expectedRefreshDuration)
    }));
  }

}

Module.instance().service('RemoteRefreshSchedules', RemoteRefreshSchedules);
